import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { PDAuthService } from 'pdauth';
import { first, map, switchMap } from 'rxjs/operators';
import { util } from '../../classes/util';
var NgAuthSleepHackTime = 500;
var UserSettingsService = /** @class */ (function () {
    function UserSettingsService(pdauth) {
        this.pdauth = pdauth;
        this.userSettingsChange = new EventEmitter();
    }
    UserSettingsService.prototype.GetSettingValue = function (settingName, appName, userEmail) {
        return this.pdauth.getUserSettings(null, appName, userEmail).pipe(map(function (val) {
            var retVal = null;
            if (val && val[settingName] !== undefined) {
                retVal = val[settingName];
            }
            return retVal;
        }));
    };
    UserSettingsService.prototype.SetSettingValue = function (settingName, value, userEmail, appName) {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            _this.pdauth.getUserSettings(null, appName, userEmail).pipe(first()).subscribe(function (userSettings) {
                var retVal = {};
                if (userSettings) {
                    retVal = userSettings;
                }
                retVal[settingName] = value;
                // This method doesn't resolve the promise it returns properly, so we're going to sleep for half a second
                // This should be updated once that method is fixed
                _this.pdauth.replaceUserSettings(retVal, userEmail, appName);
                util.sleep(NgAuthSleepHackTime).then(resolve);
                _this.userSettingsChange.emit({ settingName: settingName, value: value, userEmail: userEmail, appName: appName });
            });
        });
    };
    UserSettingsService.prototype.ClearSettingValue = function (settingName, userEmail, appName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.pdauth.getUserSettings(null, appName, userEmail).pipe(switchMap(function (userSettings) {
                        var retVal = {};
                        if (userSettings) {
                            retVal = userSettings;
                            if (retVal[settingName] !== undefined) {
                                // tslint:disable-next-line:no-dynamic-delete
                                delete retVal[settingName];
                            }
                        }
                        return _this.pdauth.updateUserSettings(retVal, userEmail, appName);
                    }))];
            });
        });
    };
    return UserSettingsService;
}());
var ɵ0 = function (pdauth) { return window.UserSettingsService ? new window.UserSettingsService() : new UserSettingsService(pdauth); };
var UserSettingsServiceProvider = {
    deps: [PDAuthService],
    provide: 'UserSettingsService',
    useFactory: ɵ0
};
export { UserSettingsServiceProvider };
export { ɵ0 };
